import WebServiceRequest from "../../../Api/WebServiceRequest";

class updateAVirtualCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VirtualCategory/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default updateAVirtualCategory;
